import React, { useState } from 'react';
import { MessageCircle, Printer, Share2, Copy, Twitter, Facebook } from 'lucide-react';
import { toast } from 'sonner';
import { APP_PUBLIC_URL } from '../config/contact';
import { COMPLIANCE_FULL } from '../config/compliance';
import { trackEvent } from '../lib/analytics';

export function printResult(title, rows, result) {
  const w = window.open('', '_blank', 'width=760,height=920');
  if (!w) { toast.error('Enable pop-ups to print'); return; }
  const rowsHtml = rows.map((r) => `<tr><td>${r.label}</td><td class="v">${r.value}</td></tr>`).join('');
  w.document.write(`<!doctype html><html><head><meta charset="utf-8"><title>Precision Wealth - ${title}</title>
    <style>
      *{font-family:Arial,Helvetica,sans-serif;box-sizing:border-box}
      body{margin:0;padding:44px;color:#0A1F44}
      .brand{font-size:13px;letter-spacing:3px;text-transform:uppercase;color:#C0975C;font-weight:700}
      h1{font-size:26px;margin:6px 0 2px}
      .sub{color:#667;font-size:13px;margin-bottom:24px}
      table{width:100%;border-collapse:collapse;margin:12px 0 20px}
      td{padding:12px 4px;border-bottom:1px solid #e6e8ee;font-size:15px}
      td.v{text-align:right;font-weight:700}
      .result{background:#0A1F44;color:#fff;padding:18px 20px;border-radius:12px;display:flex;justify-content:space-between;align-items:center}
      .result b{color:#C0975C;font-size:22px}
      .disc{color:#8891a5;font-size:11px;margin-top:24px;line-height:1.6}
    </style></head><body>
      <div class="brand">Precision Wealth</div>
      <h1>${title}</h1>
      <div class="sub">${new Date().toLocaleDateString('en-ZA', { day: '2-digit', month: 'long', year: 'numeric' })}</div>
      <table>${rowsHtml}</table>
      <div class="result"><span>${result.label}</span><b>${result.value}</b></div>
      <p class="disc">This is a general education estimate only and does not constitute financial advice under the FAIS Act. ${COMPLIANCE_FULL} For personal advice, speak to a qualified adviser.</p>
    </body></html>`);
  w.document.close();
  w.focus();
  setTimeout(() => { try { w.print(); } catch (e) { /* ignore */ } }, 450);
}

export function CalcActions({ title, rows, result }) {
  const [open, setOpen] = useState(false);
  const text = [`Precision Wealth | ${title}`, '', ...rows.map((r) => `${r.label}: ${r.value}`), '', `${result.label}: ${result.value}`, '', `Estimate only, not financial advice. Model your own at ${APP_PUBLIC_URL}`].join('\n');
  const enc = encodeURIComponent(text);
  const shares = [
    { label: 'WhatsApp', icon: MessageCircle, url: `https://wa.me/?text=${enc}` },
    { label: 'X', icon: Twitter, url: `https://twitter.com/intent/tweet?text=${enc}` },
    { label: 'Facebook', icon: Facebook, url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(APP_PUBLIC_URL)}` },
  ];
  const doShare = (s) => { trackEvent('calc_share', { calculator: title, network: s.label }); window.open(s.url, '_blank', 'noopener'); setOpen(false); };
  const copy = async () => { try { await navigator.clipboard.writeText(text); toast.success('Result copied'); } catch (e) { toast.error('Could not copy'); } trackEvent('calc_share', { calculator: title, network: 'copy' }); setOpen(false); };
  const print = () => { trackEvent('calc_print', { calculator: title }); printResult(title, rows, result); };
  return (
    <div className="flex items-center gap-2 mt-4 mb-4 relative">
      <button onClick={print} data-testid="calc-print-btn" className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg bg-white/5 hover:bg-white/10 text-white text-sm font-semibold border border-[#1D3D72] transition-colors">
        <Printer className="w-4 h-4 text-[#C0975C]" /> Print / Save
      </button>
      <button onClick={() => setOpen((o) => !o)} data-testid="calc-share-btn" className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg bg-[#C0975C] text-[#0A1F44] text-sm font-bold hover:opacity-90 transition-opacity">
        <Share2 className="w-4 h-4" /> Share
      </button>
      {open && (
        <div className="absolute right-0 bottom-full mb-2 w-44 bg-[#0A1F44] border border-[#1D3D72] rounded-xl p-2 shadow-2xl z-20" data-testid="calc-share-menu">
          {shares.map((s) => (
            <button key={s.label} onClick={() => doShare(s)} className="w-full flex items-center gap-2 px-3 py-2 rounded-lg text-white text-sm hover:bg-white/10">
              <s.icon className="w-4 h-4 text-[#C0975C]" /> {s.label}
            </button>
          ))}
          <button onClick={copy} className="w-full flex items-center gap-2 px-3 py-2 rounded-lg text-white text-sm hover:bg-white/10">
            <Copy className="w-4 h-4 text-[#C0975C]" /> Copy text
          </button>
        </div>
      )}
    </div>
  );
}
